import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from './service/userService';
import { Subscription } from 'rxjs';
import { GlobalService } from './service/globalService';
import { OAuthService } from 'angular-oauth2-oidc';
import { authConfig } from './auth.config';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';
import { UserRecord } from './model/userRecord';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  public blockControl: boolean = false;
  public subscription: Subscription;
  isAuthenticated: boolean;
  oauthEventsSub: Subscription;
  constructor(
    private userService: UserService, private globalService: GlobalService,
    public oauthService: OAuthService, private router: Router, private route: ActivatedRoute
    , private messageService: MessageService 
  ) {
    this.globalService.setLoadingOn();
    this.subscription = this.globalService.loading.subscribe((val) => {
      setTimeout(() => {
        this.blockControl = val;
      });
    });

    this.oauthService.configure(authConfig);
    this.oauthService.tokenValidationHandler = new JwksValidationHandler();
    this.setupCrossTabLogout();
  }
  async ngOnInit() {
    // Start listening FIRST to capture events 'token_received'
    this.setoAuthEventsStub();

    try {
      // Load the config and Wait for the library to finish checking storage/URL
      const success = await this.oauthService.loadDiscoveryDocumentAndTryLogin();
      console.log('Success', success);
      // If we don't have a valid session and we aren't in a login redirect, start login
      if (!this.oauthService.hasValidIdToken()) {
        this.oauthService.initImplicitFlow();
      } else {
        console.log('existing valid session detected');
        this.handlePostLoginSuccess();
      }
    } catch (err) {
      if(err.type === 'token_error'){
        //User+is+not+assigned+to+the+client+application.
      }
      localStorage.removeItem('currentUser');
      this.router.navigate(['no-auth']);
      console.error('Auth initialization failed', err);
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
    if (this.oauthEventsSub) {
      this.oauthEventsSub.unsubscribe();
    }
  }
  private setupCrossTabLogout(): void {
    window.addEventListener('storage', (event) => {
      // listen for the removal of the access token from localStorage
      if (event.storageArea === localStorage && event.key === 'access_token' && !event.newValue) {
        console.warn('Logout detected in another tab. Cleaning up...');
        this.oauthService.logOut();
        this.oauthService.loadDiscoveryDocumentAndLogin();
      }
    });
  }
  private setoAuthEventsStub(): void {
    this.oauthEventsSub = this.oauthService.events.subscribe(e => {
      console.log('OAuth event:', e.type);
       if (e.type === 'token_received') {
        // Manually clear the hash after login so the Router doesn't get confused
        location.hash = '';
        return;
      }
      if (['token_refreshed', 'user_profile_loaded'].includes(e.type)) {
        return;
      }
      if (e.type === 'token_expires') {
        console.log('Token expiring soon');
        return; // Don't logout! Let the library handle it.
      }
      if (e.type === 'silent_refresh_error' || e.type === 'silent_refresh_timeout') {
        this.oauthService.logOut();
        this.router.navigate(['/login']);
      }
      // Logout/Termination Events - Keep these to sync UI
      if (['session_terminated', 'session_error', 'token_expires'].includes(e.type)) {
        console.warn('Session ended or token expired:', e.type);
        this.oauthService.logOut(); 
        this.router.navigate(['/login']);
        return;
      }

      if (e.type === 'invalid_nonce_in_state') {
        console.error('Auth Security Error:', e.type);
      }
    });
  }
  private handlePostLoginSuccess(): void {
    localStorage.setItem('token', this.oauthService.getAccessToken());
    const claims = this.oauthService.getIdentityClaims();
    this.userService.getUserByEmail(claims['preferred_username']).subscribe(
      data => {
        if (data) {
          console.log('response')
          const user = new UserRecord().deserialize(data);
          this.userService.getUserToken(user.username).subscribe(
            result => {
              if (result) {
                this.globalService.UserToken = result;
                localStorage.removeItem('currentUser');
                localStorage.setItem('currentUser', JSON.stringify(user));
              } else {
                localStorage.removeItem('currentUser');
                this.router.navigate(['no-auth']);
              }
            },
            error => {
              console.log(error);
              this.messageService.clear();
              this.messageService.add({
                severity: 'error',
                summary: 'There was an error retrieving api token from server',
                detail: error.message
              });
              localStorage.removeItem('currentUser');
              this.router.navigate(['no-auth']);
              this.globalService.setLoadingOff();
            }
          );
        } else {
          this.router.navigate(['/login']);
        }
      },
      error => {
        console.log(error);
        this.messageService.clear();
        this.messageService.add({
          severity: 'error',
          summary: 'There was an error retrieving user records from server',
          detail: error.message
        });
        localStorage.removeItem('currentUser');
        this.router.navigate(['no-auth']);
        this.globalService.setLoadingOff();
      }
    );
  }
}
